/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca, Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';
import { slug } from '../../common';
import LevelChangedNotification from './components/LevelChangedNotification';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.settings`;

export default function () {
	app.notificationComponents.levelChanged = LevelChangedNotification;

	extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
		if (app.forum.attribute(`${slug}.gamification.enabled`) && app.forum.attribute(`${slug}.levels.enabled`)) {
			items.add('levelChanged', {
				name: 'levelChanged',
				icon: 'fas fa-diamond',
				label: t(`${prfx}.notify_level_changed`),
			});
		}
	});
}
